export default {"src":"/_next/static/media/akasa_preloader.6462a42f.gif","height":500,"width":500};